export default __webpack_public_path__ + "static/media/international.8a7a53f4.svg";